import { post } from "@/requests/server";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    id: null,
    code: null,
    communityName: "",
    inviterName: "",
    accountExists: false,
    newlyAcceptedCommunityId: null,
  },
  mutations: {
    setInvitation(state, { id, code, communityName, inviterName, accountExists, email }) {
      state.id = id;
      state.code = code;
      state.communityName = communityName;
      state.inviterName = inviterName;
      state.accountExists = accountExists;
      state.email = email;
    },
    clear(state) {
      state.id = null;
      state.code = null;
      state.communityName = "";
      state.inviterName = "";
      state.accountExists = false;
      state.email = "";
    },
    setNewlyAcceptedCommunityId(state, communityId) {
      state.newlyAcceptedCommunityId = communityId;
    },
  },
  actions: {
    async accept({ state, commit, dispatch }) {
      const { data: acceptedInvitation } = await post(
        `invitations/${state.id}/accept`,
        {
          code: state.code,
        },
        { notifications: { action: i18n.t("store.invitation.notifications.accept.action") } }
      );

      if (acceptedInvitation) {
        await commit("setNewlyAcceptedCommunityId", acceptedInvitation.community_id);
        await commit("clear");
        await dispatch("loadUser", {}, { root: true });
        await commit(
          "addNotification",
          {
            title: i18n.t("store.invitation.notifications.accept.success.title"),
            variant: "success",
          },
          { root: true }
        );
      }
    },
    async acceptById({ commit, dispatch }, { id }) {
      const { data: acceptedInvitation } = await post(`invitations/${id}/accept`, undefined, {
        notifications: { action: i18n.t("store.invitation.notifications.accept.action") },
      });

      if (acceptedInvitation) {
        await commit("setNewlyAcceptedCommunityId", acceptedInvitation.community_id);
        await commit("clear");
        await dispatch("loadUser", {}, { root: true });
        await commit(
          "addNotification",
          {
            title: i18n.t("store.invitation.notifications.accept.success.title"),
            variant: "success",
          },
          { root: true }
        );
      }
    },
    async acceptOnRegistration({ commit, dispatch }) {
      const { data: acceptedInvitation } = await post(`invitations/accept/registration`, {
        notifications: {
          action: i18n.t("store.invitation.notifications.accept_on_registration.action"),
        },
      });
      if (acceptedInvitation) {
        await commit("setNewlyAcceptedCommunityId", acceptedInvitation.community_id);
        await commit("clear");
        await dispatch("loadUser", {}, { root: true });
        await commit(
          "addNotification",
          {
            title: i18n.t("store.invitation.notifications.accept.success.title"),
            variant: "success",
          },
          { root: true }
        );
      }
    },
    async refuseById({ dispatch }, { id }) {
      await post(`invitations/${id}/refuse`, undefined, {
        notifications: { action: i18n.t("store.invitation.notifications.refuse.action") },
      });

      await dispatch("loadUser", {}, { root: true });
    },
  },
};
